// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"729":"749566bb","2947":"11b01132"}[chunkId] + ".chunk.css";
};